import React from 'react';
import { ServicePage } from './ServicePage';
import { getService } from '../data/services';
const service = getService('crm-integrations');
export function CrmIntegrationsPage() {
  if (!service) return null;
  return <ServicePage service={service} data-id="element-187" data-mp="338salhepv7s9" />;
}